import { tv, type VariantProps } from 'tailwind-variants';

export type OrCardsListVariants = VariantProps<typeof orCardsListVariants>;

const orCardsListVariants = tv({
  base: '',
  slots: {
    mainContainer: 'flex flex-col mx-auto container',
    cardsContainer: 'grid grid-flow-col gap-7 md:grid-flow-row',
    header: 'mb-[5.62rem] w-full md:w-1/2',
  },
  variants: {
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
    totalCards: {
      '2': {
        cardsContainer: 'grid-rows-2 md:grid-cols-2 md:grid-rows-1',
      },
      '3': {
        cardsContainer:
          'grid-rows-3 md:grid-cols-2 md:grid-rows-2 md:[&>div:last-child]:col-span-2 lg:grid-cols-3 lg:grid-rows-1 lg:[&>div:last-child]:col-span-1',
      },
      '4': {
        cardsContainer:
          'grid-rows-4 md:grid-cols-2 md:grid-rows-2 lg:grid-cols-4 lg:grid-rows-1',
      },
    },
    alignment: {
      left: { mainContainer: 'items-start justify-start text-left' },
      center: { mainContainer: 'items-center justify-center text-center' },
      right: { mainContainer: 'items-end justify-end text-right' },
    },
  },
  compoundVariants: [],
});

export default orCardsListVariants;
